export const articlesAnalysisStructure = [
  {
    slug: 'candle-reading-basics',
    category: 'วิเคราะห์ Forex',
    categorySlug: 'forex-analysis',
    title: 'วิธีอ่านกราฟแท่งเทียนสำหรับมือใหม่',
    description:
      'เริ่มอ่านกราฟแท่งเทียนอย่างเป็นระบบ ตั้งแต่การดูแกนราคา แกนเวลา ไปจนถึงการอ่านแท่งเดียวและแท่งต่อเนื่องกัน',
    readingTime: '7 นาที',
    updatedDate: '2026-10-17',
    level: 'เริ่มต้น',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20candlestick%20chart%20grid%20on%20clean%20light%20background%20with%20teal%20bars%20and%20warm%20orange%20axis%20guides%20editorial%20flat%20fintech%20illustration%20no%20text%20no%20people&width=1200&height=675&seq=art-candle-reading-basics-01&orientation=landscape',
    tags: ['แท่งเทียน', 'อ่านกราฟ', 'พื้นฐาน'],
    intro: [
      'กราฟแท่งเทียนคือการนำราคาในช่วงเวลาต่าง ๆ มาต่อกันเป็นภาพเดียว ทำให้เห็นทั้งทิศทางและอารมณ์ของตลาดในหน้าจอเดียว',
      'ก่อนจะจำชื่อรูปแบบต่าง ๆ สิ่งที่ควรทำได้ก่อนคือการอ่านแกนทั้งสองและเล่าได้ว่าช่วงที่เห็นราคาทำอะไรลงไป',
    ],
    sections: [
      {
        id: 'axes',
        heading: 'เริ่มจากแกนสองด้าน',
        paragraphs: [
          'แกนตั้งคือราคา ส่วนแกนนอนคือเวลา ทุกแท่งกินพื้นที่หนึ่งช่วงเวลาเท่ากัน เช่น หนึ่งชั่วโมงหรือหนึ่งวัน การรู้ว่าหนึ่งแท่งแทนเวลาเท่าไรคือจุดเริ่มต้นที่ขาดไม่ได้',
        ],
        bullets: ['แกนตั้งบอกระดับราคา ไม่ได้บอกจำนวนคนซื้อขาย', 'หนึ่งแท่ง = หนึ่งช่วงเวลาตามกรอบที่เลือก', 'ระยะห่างของแกนราคาไม่เท่ากันในแต่ละคู่เงิน'],
        steps: [],
      },
      {
        id: 'single',
        heading: 'อ่านทีละแท่ง',
        paragraphs: [
          'ในแต่ละแท่งให้ถามว่าอะไรเกิดขึ้นระหว่างช่วงเวลานั้น ราคาเปิดที่ไหน ปิดที่ไหน และวิ่งไปไกลแค่ไหนก่อนจบช่วง',
          'ตัวแท่งบอกผลลัพธ์ ส่วนไส้บอกเส้นทางที่ราคาเดิน ถ้าไส้ยาวผิดปกติ แปลว่ามีแรงต้านหรือแรงรับเข้ามาแทรกกลางทาง',
        ],
        bullets: ['ตัวแท่งยาว = ฝั่งหนึ่งคุมเกมได้ชัด', 'ตัวแท่งสั้น = ตลาดลังเล', 'ไส้ยาวข้างเดียว = มีการผลักกลับแรง'],
        steps: [],
      },
      {
        id: 'sequence',
        heading: 'อ่านเป็นลำดับ ไม่ใช่แท่งเดียว',
        paragraphs: [
          'แท่งเดียวไม่พอจะบอกอะไรได้มากนัก สิ่งที่มีความหมายคือลำดับ เช่น แท่งยาวตามด้วยแท่งเล็กสองสามแท่งที่ยืนเหนือครึ่งของแท่งแรก มักหมายถึงการพักราคามากกว่าการกลับตัว',
          'ตัวอย่างที่ชัดคือแท่งขาขึ้นยาว 60 Pip ตามด้วยแท่งเล็ก 3 แท่งที่ปิดเหนือครึ่งของแท่งแรก ถือว่าราคายังยืนได้และมีโอกาสไปต่อ แต่ถ้าแท่งที่สองปิดต่ำกว่าจุดกึ่งกลางของแท่งแรกมากกว่า 70% ของความยาว แปลว่าแรงซื้อเริ่มอ่อนและมีโอกาสย้อนกลับสูงขึ้น',
        ],
        bullets: [],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'ต้องจำชื่อแท่งเทียนทุกแบบไหม',
        a: 'ไม่จำเป็นสำหรับมือใหม่ การเข้าใจว่าแรงซื้อแรงขายเกิดตรงไหนในแท่งสำคัญกว่าการจำชื่อ เพราะชื่อส่วนใหญ่มาจากโครงสร้างเดียวกัน',
        a2: 'ตัวเลขที่ช่วยได้คือ แท่งเทียนที่มีชื่อเฉพาะมีราว 20-30 รูปแบบ แต่ที่ใช้ได้จริงบ่อยมีไม่ถึง 10 รูปแบบ เช่น Doji, Hammer, Engulfing และ Pin Bar สำหรับมือใหม่ควรรู้แค่ 4-5 รูปแบบและดูตำแหน่งที่เกิดประกอบ',
      },
      {
        q: 'กราฟแท่งเทียนกับกราฟเส้นต่างกันอย่างไร',
        a: 'กราฟเส้นแสดงเฉพาะราคาปิด ทำให้อ่านง่ายแต่ขาดข้อมูลไส้ ส่วนแท่งเทียนให้ข้อมูลสี่ราคาในแท่งเดียว จึงเหมาะกับการอ่านอารมณ์ตลาดมากกว่า',
        a2: 'ตัวเลขที่ต่างชัดคือ กราฟเส้นให้ข้อมูล 1 ราคาต่อแท่ง ส่วนแท่งเทียนให้ 4 ราคา คือเปิด สูง ต่ำ ปิด ซึ่งหมายถึงข้อมูลมากกว่า 4 เท่าในพื้นที่เท่ากัน นี่คือเหตุผลที่แท่งเทียนอ่านแรงซื้อแรงขายได้ละเอียดกว่า',
      },
    ],
    related: ['reading-candlestick-charts', 'bullish-bearish-candlesticks', 'forex-chart-timeframes'],
  },
  {
    slug: 'forex-chart-timeframes',
    category: 'วิเคราะห์ Forex',
    categorySlug: 'forex-analysis',
    title: 'กรอบเวลาในกราฟ Forex คืออะไร',
    description:
      'อธิบายความหมายของกรอบเวลา M15 H1 H4 และ D1 พร้อมผลของการเปลี่ยนกรอบเวลาต่อการอ่านแนวโน้มและสัญญาณ',
    readingTime: '6 นาที',
    updatedDate: '2026-10-15',
    level: 'เริ่มต้น',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20multi%20timeframe%20chart%20panels%20illustration%20teal%20candlesticks%20in%20nested%20frames%20on%20clean%20light%20background%20editorial%20flat%20fintech%20design%20no%20text&width=1200&height=675&seq=art-forex-chart-timeframes-01&orientation=landscape',
    tags: ['กรอบเวลา', 'อ่านกราฟ', 'พื้นฐาน'],
    intro: [
      'กรอบเวลาคือความยาวของช่วงเวลาที่แต่ละแท่งเทียนแทน ตั้งแต่หนึ่งนาทีไปจนถึงหนึ่งสัปดาห์',
      'การเปลี่ยนกรอบเวลาไม่ได้แค่ซูมภาพเข้า ออก แต่เปลี่ยนความหมายของสิ่งที่เห็นทั้งหมด',
    ],
    sections: [
      {
        id: 'meaning',
        heading: 'ตัวเลขบนกรอบเวลาหมายถึงอะไร',
        paragraphs: [
          'M15 คือแท่งละ 15 นาที H1 คือแท่งละหนึ่งชั่วโมง D1 คือแท่งละหนึ่งวัน ยิ่งกรอบใหญ่ หนึ่งแท่งยิ่งบรรจุข้อมูลมาก และยิ่งตอบสนองช้า',
        ],
        bullets: ['M5–M15 ละเอียด แต่มีสัญญาณรบกวนมาก', 'H1–H4 สมดุลระหว่างรายละเอียดกับภาพรวม', 'D1–W1 ใช้ดูบริบทระยะยาว'],
        steps: [],
      },
      {
        id: 'nested',
        heading: 'กรอบใหญ่กำหนด กรอบเล็กหาจังหวะ',
        paragraphs: [
          'วิธีที่ใช้ง่ายที่สุดคือใช้สองกรอบเวลาคู่กัน กรอบใหญ่บอกว่าควรเอียงไปทางไหน กรอบเล็กใช้หาจุดเข้าที่สอดคล้องกับทิศทางนั้น',
        ],
        bullets: ['เลือกกรอบใหญ่หนึ่งกรอบเป็นตัวกำหนดทิศทาง', 'เลือกกรอบเล็กหนึ่งกรอบสำหรับจุดเข้า', 'ถ้าสองกรอบขัดกัน ให้หยุดและรอ'],
        steps: [],
      },
      {
        id: 'mistake',
        heading: 'ข้อผิดพลาดที่พบบ่อย',
        paragraphs: [
          'การเปลี่ยนกรอบเวลาไปมาจนเจอสัญญาณที่อยากเห็นคือกับดักที่พบบ่อย เพราะกรอบไหนก็มีสัญญาณขัดกันเสมอ ควรกำหนดกรอบล่วงหน้าแล้วยึดตามนั้น',
          'วิธีที่ชัดเจนคือเลือก 3 กรอบตายตัว เช่น D1 H4 M15 แล้วเขียนกฎว่า D1 กำหนดทิศ ห้ามเปิดออเดอร์สวนทิศนั้น และ M15 ใช้แค่หาจุดเข้าเท่านั้น การเปลี่ยนไปดู M5 เพราะสัญญาณบน M15 ไม่สวย มักทำให้เปิดไม้ที่ Stop Loss สั้นเกินจนถูกตัดด้วยเสียงรบกวนปกติของตลาด',
        ],
        bullets: [],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'มือใหม่ควรเริ่มจากกรอบเวลาไหน',
        a: 'เริ่มจาก H1 หรือ H4 เพื่อให้เห็นภาพรวมชัดและมีเวลาเพียงพอในการตัดสินใจ กรอบเวลานาทีจะเร็วเกินไปและทำให้เกิดการเทรดเกินจำเป็น',
        a2: 'ตัวเลขที่ใช้ได้คือ H4 ให้แท่งใหม่ทุก 4 ชั่วโมง หรือ 6 แท่งต่อวัน ทำให้มีเวลาเพียงพอในการตัดสินใจ ส่วน M5 ให้ 288 แท่งต่อวัน ซึ่งสร้างสัญญาณหลอกมากกว่าหลายเท่าสำหรับคนที่ยังอ่านโครงสร้างไม่คล่อง',
      },
      {
        q: 'ใช้กรอบเวลาเดียวได้ไหม',
        a: 'ใช้ได้ แต่จะพลาดบริบทระยะยาว อย่างน้อยควรดูกรอบใหญ่กว่าหนึ่งระดับเพื่อยืนยันทิศทาง',
        a2: 'ตัวอย่างที่ชัดคือ ถ้าดูแค่ H1 คุณอาจเห็นขาขึ้น แต่พอมอง D1 กลับพบว่าราคายังอยู่ใต้แนวต้านใหญ่ การดูกรอบใหญ่กว่าหนึ่งระดับช่วยลดการเข้าซื้อที่ปลายแนวโน้มได้มาก',
      },
    ],
    related: ['reading-candlestick-charts', 'forex-timeframe-selection', 'forex-trend-direction'],
  },
  {
    slug: 'bullish-bearish-candlesticks',
    category: 'วิเคราะห์ Forex',
    categorySlug: 'forex-analysis',
    title: 'แท่งเทียนขาขึ้นและขาลงแตกต่างกันอย่างไร',
    description:
      'แยกความต่างของแท่งเทียนขาขึ้นและขาลง พร้อมอ่านความหมายของตัวแท่งและไส้ในแต่ละทิศทางอย่างถูกต้อง',
    readingTime: '6 นาที',
    updatedDate: '2026-10-13',
    level: 'เริ่มต้น',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20pair%20of%20bullish%20teal%20candle%20and%20bearish%20warm%20orange%20candle%20side%20by%20side%20on%20clean%20light%20background%20editorial%20flat%20fintech%20illustration%20no%20text&width=1200&height=675&seq=art-bullish-bearish-candles-01&orientation=landscape',
    tags: ['แท่งเทียน', 'ขาขึ้น', 'ขาลง'],
    intro: [
      'แท่งเทียนขาขึ้นคือแท่งที่ราคาปิดสูงกว่าราคาเปิด ส่วนแท่งขาลงคือแท่งที่ราคาปิดต่ำกว่าราคาเปิด',
      'แต่ความต่างที่แท้จริงไม่ได้อยู่ที่สี อยู่ที่ว่าใครเป็นฝ่ายคุมเกมตลอดช่วงเวลานั้น',
    ],
    sections: [
      {
        id: 'direction',
        heading: 'ทิศทางของแท่ง',
        paragraphs: [
          'แท่งขาขึ้นแสดงว่าช่วงเวลานั้นจบลงด้วยราคาสูงกว่าตอนเริ่ม ส่วนแท่งขาลงจบลงด้วยราคาต่ำกว่าตอนเริ่ม การเปรียบเทียบนี้ทำในกรอบเวลาเดียวกันเสมอ',
        ],
        bullets: ['แท่งขาขึ้น: ปิดสูงกว่าเปิด', 'แท่งขาลง: ปิดต่ำกว่าเปิด', 'แท่งโดจิ: เปิดและปิดใกล้กันมาก'],
        steps: [],
      },
      {
        id: 'wick',
        heading: 'ไส้บอกอะไรที่ตัวแท่งไม่บอก',
        paragraphs: [
          'แท่งขาขึ้นที่ไส้บนยาวมากหมายความว่าราคาเคยขึ้นไปสูง แต่มีแรงขายดันกลับลงมาจนปิดต่ำกว่าจุดสูงสุดมาก นี่คือสัญญาณว่าฝั่งซื้อไม่ได้คุมเกมเต็มที่',
          'ในทางกลับกัน แท่งขาลงที่ไส้ล่างยาว บอกว่ามีแรงซื้อเข้ามารับจนราคากลับขึ้น',
        ],
        bullets: ['ไส้คือระยะที่ราคาไปแล้วถูกปฏิเสธ', 'ไส้ยาวขึ้นเรื่อย ๆ = แรงต้านฝั่งนั้นเพิ่ม', 'แท่งเล็กไส้ยาวทั้งสองข้าง = ความลังเล'],
        steps: [],
      },
      {
        id: 'context',
        heading: 'อย่าตัดสินจากแท่งเดี่ยว',
        paragraphs: [
          'แท่งขาขึ้นขนาดใหญ่ที่เกิดกลางโซนแนวต้านสำคัญอาจหมายถึงแรงซื้อสุดท้ายก่อนถูกกดกลับ ในขณะที่แท่งเดียวกันที่เกิดหลังเบรกแนวต้านอาจเป็นการยืนยันกำลัง',
          'ข้อสังเกตที่ใช้ได้จริงคือให้ดูว่าแท่งนั้นปิดตรงไหน ถ้าแท่งยาว 50 Pip แต่ปิดเหลือไส้บน 30 Pip แปลว่ามีแรงขายสวนกลับชัดเจน ถ้าเกิดที่โซนแนวต้าน ให้นับเป็นสัญญาณอ่อนแรง แต่ถ้าแท่งเดียวกันปิดเกือบเต็มแท่งเหนือโซนที่เพิ่งเบรก นั่นคือการยืนยันว่าฝั่งซื้อคุมเกมอยู่',
        ],
        bullets: [],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'สีแท่งเทียนสำคัญไหม',
        a: 'สีเป็นเพียงตัวช่วยอ่านเร็ว ไม่ได้เพิ่มข้อมูลใหม่ ทุกอย่างที่สีบอกสามารถอ่านได้จากราคาเปิดและราคาปิด',
        a2: 'ตัวเลขที่ควรรู้คือ แท่งที่มีตัวเล็กและไส้ยาวทั้งสองข้าง (Doji) บอกว่าฝั่งซื้อและฝั่งขายสูสีกัน ไม่ได้บอกว่าอะไรจะเกิดต่อไป ถ้าดูเฉพาะสี คุณจะพลาดข้อมูลเรื่องตำแหน่งของราคาเปิดและปิดซึ่งสำคัญกว่า',
      },
      {
        q: 'แท่งขาขึ้นยาวแปลว่าต้องซื้อไหม',
        a: 'ไม่ใช่ แท่งยาวบอกว่าโมเมนตัมฝั่งซื้อแรงในกรอบเวลานั้น แต่ต้องดูตำแหน่งว่าเกิดที่ไหนและกรอบใหญ่สนับสนุนหรือไม่',
        a2: 'ตัวเลขที่ช่วยได้คือ แท่ง H1 ที่เคลื่อนเกิน 30 Pip ในคู่เงินหลักถือว่าผิดปกติ ถ้าเกิดที่ปลายขาขึ้นหลังขึ้นมา 150-200 Pip ให้ระวังการย้อนกลับมากกว่าจะเข้าซื้อตาม เพราะแรงซื้อมักถูกใช้ไปแล้ว',
      },
    ],
    related: ['reading-candlestick-charts', 'candle-reading-basics', 'support-resistance'],
  },
  {
    slug: 'sideways-market',
    category: 'วิเคราะห์ Forex',
    categorySlug: 'forex-analysis',
    title: 'ตลาด Sideways คืออะไร และสังเกตได้อย่างไร',
    description:
      'รู้จักตลาดไซด์เวย์หรือตลาดไร้แนวโน้ม วิธีสังเกตกรอบราคา และเหตุผลที่สัญญาณตามแนวโน้มมักใช้ไม่ได้ในช่วงนี้',
    readingTime: '7 นาที',
    updatedDate: '2026-10-12',
    level: 'เริ่มต้น',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20sideways%20range%20market%20illustration%20teal%20candles%20moving%20inside%20two%20horizontal%20warm%20orange%20band%20lines%20clean%20light%20background%20editorial%20flat%20fintech%20no%20text&width=1200&height=675&seq=art-sideways-market-01&orientation=landscape',
    tags: ['ไซด์เวย์', 'แนวโน้ม', 'โครงสร้างตลาด'],
    intro: [
      'ตลาดไซด์เวย์คือช่วงที่ราคาแกว่งขึ้นลงอยู่ในกรอบเดิม โดยไม่ทำจุดสูงใหม่หรือจุดต่ำใหม่ที่ชัดเจน',
      'ตลาดแบบนี้กินเวลาส่วนใหญ่ของกราฟ การรู้จักมันจึงสำคัญพอ ๆ กับการรู้จักแนวโน้ม',
    ],
    sections: [
      {
        id: 'signals',
        heading: 'สังเกตจากอะไร',
        paragraphs: [
          'จุดสูงและจุดต่ำหลายรอบอยู่ในระดับใกล้เคียงกัน ระยะการแกว่งแคบลง และแท่งเทียนมีขนาดสั้นสลับกันไปมาโดยไม่มีทิศทาง',
        ],
        bullets: ['จุดสูงเดิมถูกแตะซ้ำหลายครั้ง', 'จุดต่ำเดิมยืนได้ตลอด', 'แท่งเทียนส่วนใหญ่มีไส้ยาวและตัวสั้น'],
        steps: [],
      },
      {
        id: 'tools',
        heading: 'เครื่องมือที่ใช้ได้และใช้ไม่ได้',
        paragraphs: [
          'ในตลาดไซด์เวย์ อินดิเคเตอร์ตามแนวโน้มอย่าง Moving Average มักตัดกันไปมาและให้สัญญาณหลอก ส่วนเครื่องมือวัดโมเมนตัมอย่าง RSI ก็อาจค้างในโซนสุดโต่งได้นาน',
        ],
        bullets: ['หลีกเลี่ยงการตามสัญญาณตัดกันของเส้น', 'ใช้ขอบกรอบเป็นจุดอ้างอิง', 'ยอมรับว่ากรอบอาจหลุดได้ทุกเมื่อ'],
        steps: [],
      },
      {
        id: 'wait',
        heading: 'บางครั้งคำตอบที่ดีที่สุดคือรอ',
        paragraphs: [
          'เมื่ออ่านไม่ออกว่ากรอบจะไปทางไหน การไม่เปิดออเดอร์ก็เป็นผลลัพธ์ที่ถูกต้อง การบังคับเทรดในตลาดไร้ทิศทางคือสาเหตุต้น ๆ ของการขาดทุนต่อเนื่อง',
          'ตัวเลขที่ช่วยให้ใจเย็นขึ้นคือในหนึ่งสัปดาห์มีช่วงที่ตลาดไซด์เวย์อยู่ประมาณครึ่งหนึ่งของเวลา ถ้าเลือกไม่เทรดในชวงนั้น ก็ยังเหลืออีกครึ่งที่แนวโน้มชัดและมีอัตราถูกต้องสูงกว่า สิ่งที่ควรหลีกเลี่ยงคือการเปิดไม้เล็ก ๆ สิบครั้งเพื่อความคึกคัก เพราะต้นทุน Spread รวมจะกินกำไรจนหมด',
        ],
        bullets: [],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'ตลาดไซด์เวย์ต่างจากแนวโน้มอย่างไร',
        a: 'แนวโน้มมีทิศทางชัดจากจุดสูงจุดต่ำที่ไล่ขึ้นหรือไล่ลง ส่วนไซด์เวย์คือจุดสูงจุดต่ำอยู่ในกรอบแนวนอนเดิม',
        a2: 'ตัวเลขที่ใช้กำหนดได้คือ ถ้าราคาแกว่งในช่วง 40-60 Pip ติดต่อกันเกิน 20 แท่ง ให้ถือว่าเป็นไซด์เวย์ และควรเล่นจากขอบกรอบเข้าหากลางด้วยเป้า 60-70% ของความกว้างกรอบ เพราะการรอให้ถึงอีกด้านมักพลาด',
      },
      {
        q: 'ตลาดไซด์เวย์เทรดได้ไหม',
        a: 'ทำได้หากมีแผนชัดเจนสำหรับการเล่นในกรอบ และกำหนดจุดผิดไว้ก่อน แต่ควรลดขนาดความเสี่ยงเพราะกรอบหลุดได้ง่าย',
        a2: 'วิธีที่ลดความเสียหายได้คือ ลดขนาดสถานะลงครึ่งหนึ่งเมื่อเล่นในกรอบ และตั้งจุดผิดห่างจากขอบกรอบอย่างน้อย 10-15 Pip เพราะกรอบมักถูกกวาดไส้ก่อนกลับ ซึ่งทำให้จุดผิดที่ชิดเกินไปถูกชนบ่อย',
      },
    ],
    related: ['forex-trend-direction', 'support-resistance', 'higher-high-lower-low'],
  },
  {
    slug: 'trendline-drawing',
    category: 'วิเคราะห์ Forex',
    categorySlug: 'forex-analysis',
    title: 'วิธีลากเส้นแนวโน้มบนกราฟ Forex',
    description:
      'ขั้นตอนการลากเส้นแนวโน้มจากจุดสูงจุดต่ำจริง พร้อมข้อผิดพลาดที่ทำให้เส้นแนวโน้มกลายเป็นภาพหลอกตัวเอง',
    readingTime: '7 นาที',
    updatedDate: '2026-10-11',
    level: 'เริ่มต้น',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20diagonal%20trendline%20drawn%20across%20teal%20candlestick%20chart%20on%20clean%20light%20background%20with%20warm%20orange%20anchor%20dots%20editorial%20flat%20fintech%20no%20text&width=1200&height=675&seq=art-trendline-drawing-01&orientation=landscape',
    tags: ['เส้นแนวโน้ม', 'อ่านกราฟ', 'แนวโน้ม'],
    intro: [
      'เส้นแนวโน้มคือเส้นตรงที่ลากเชื่อมจุดต่ำในขาขึ้น หรือจุดสูงในขาลง เพื่อใช้ดูว่าจังหวะของราคายังสอดคล้องกับทิศทางเดิมหรือไม่',
      'มันเป็นเครื่องมือช่วยมองภาพ ไม่ใช่กฎของตลาด จึงต้องลากจากสิ่งที่กราฟให้มา ไม่ใช่จากสิ่งที่เราอยากเห็น',
    ],
    sections: [
      {
        id: 'how',
        heading: 'ลากจากจุดไหน',
        paragraphs: [
          'ในขาขึ้น ให้เริ่มจากจุดต่ำสำคัญที่สุดของแนวโน้มนั้น แล้วลากผ่านจุดต่ำถัดไปที่ราคาเด้งกลับจริง ต้องมีอย่างน้อยสองจุดแตะจึงจะเรียกว่าเส้นแนวโน้ม',
        ],
        bullets: ['อย่างน้อยสองจุดแตะจึงมีความหมาย', 'จุดที่สามคือจุดทดสอบว่าเส้นยังใช้ได้', 'หลีกเลี่ยงการลากผ่านไส้เพียงเพื่อให้พอดี'],
        steps: [],
      },
      {
        id: 'use',
        heading: 'ใช้เส้นอย่างไร',
        paragraphs: [
          'ใช้ดูว่าจังหวะของราคายังอยู่ในเส้นหรือเริ่มผ่อนลง และใช้เป็นการเตือนว่าถ้าราคาหลุดเส้น พฤติกรรมของตลาดอาจกำลังเปลี่ยน',
        ],
        bullets: ['ระยะห่างจากเส้นบอกความแข็งแรงของจังหวะ', 'การหลุดเส้นไม่ใช่สัญญาณกลับตัวทันที', 'ควรตรวจกรอบเวลาใหญ่อีกครั้ง'],
        steps: [],
      },
      {
        id: 'mistake',
        heading: 'ข้อผิดพลาดที่ควรเลี่ยง',
        paragraphs: [
          'การลากเส้นใหม่ทุกครั้งที่ราคาหลุด เพื่อให้เส้นยังดูใช้ได้ คือการหลอกตัวเอง ควรยอมรับว่าเส้นเดิมถูกทำลาย แล้วประเมินโครงสร้างใหม่ตั้งแต่ต้น',
          'หลักที่ใช้ตัดสินคือถ้าแท่งปิดหลุดเส้นเดิมเกิน 10 ถึง 15 Pip บน H4 ถือว่าโครงสร้างเดิมจบแล้ว ให้ลบเส้นทิ้งแล้วรอโครงสร้างใหม่ก่อตัวขึ้น 1 ถึง 2 สัปดาห์ก่อนวางแผนไม้ใหม่ การขยับเส้นตามราคาทุกครั้งจะทำให้เข้าใจตลาดผิดและไม่เคยเรียนรู้ว่าการคาดการณ์ผิดหน้าตาเป็นอย่างไร',
        ],
        bullets: [],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'ต้องลากผ่านไส้หรือตัวแท่ง',
        a: 'ไม่มีคำตอบตายตัว แต่ควรเลือกวิธีเดียวและใช้อย่างสม่ำเสมอ หลายคนลากผ่านไส้ในกรอบใหญ่และผ่านตัวแท่งในกรอบเล็ก',
        a2: 'ตัวเลขที่ใช้ได้คือ เส้นแนวโน้มที่มีคุณภาพควรถูกแตะอย่างน้อย 2-3 ครั้งโดยไม่ต้องขยับจุดยึด ถ้าต้องลากใหม่เกิน 2 ครั้ง แปลว่าเส้นนั้นไม่ได้สะท้อนโครงสร้างจริง และควรใช้เส้นแนวนอนแทน',
      },
      {
        q: 'เส้นแนวโน้มใช้กับตลาดไซด์เวย์ได้ไหม',
        a: 'ไม่ค่อยมีประโยชน์ เพราะไม่มีทิศทางให้ลาก ในตลาดไซด์เวย์ควรใช้เส้นแนวนอนกำหนดขอบกรอบแทน',
        a2: 'ตัวเลือกที่ตรงกว่าคือลากเส้นแนวนอนที่ขอบบนและขอบล่างของกรอบ แล้วรอการเบรกพร้อมแท่งปิด ถ้าต้องการใช้เส้นเอียงในตลาดไซด์เวย์ แสดงว่ากำลังฝืนหารูปแบบที่ไม่มีอยู่',
      },
    ],
    related: ['forex-trend-direction', 'support-resistance', 'sideways-market'],
  },
  {
    slug: 'higher-high-lower-low',
    category: 'วิเคราะห์ Forex',
    categorySlug: 'forex-analysis',
    title: 'Higher High และ Lower Low คืออะไร',
    description:
      'เข้าใจโครงสร้างตลาดผ่าน Higher High Higher Low และ Lower High Lower Low พร้อมวิธีใช้กำหนดบริบทก่อนหาจุดเข้า',
    readingTime: '7 นาที',
    updatedDate: '2026-10-10',
    level: 'ปานกลาง',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20market%20structure%20break%20diagram%20teal%20swing%20highs%20and%20lows%20with%20warm%20orange%20labels%20on%20clean%20light%20background%20editorial%20flat%20fintech%20illustration%20no%20text&width=1200&height=675&seq=art-hh-lower-low-01&orientation=landscape',
    tags: ['โครงสร้างตลาด', 'แนวโน้ม', 'Swing'],
    intro: [
      'Higher High (HH) คือจุดสูงใหม่ที่สูงกว่าจุดสูงก่อนหน้า ส่วน Higher Low (HL) คือจุดต่ำใหม่ที่ยกขึ้นจากจุดต่ำเดิม',
      'การอ่านลำดับของจุดเหล่านี้คือวิธีที่ตรงที่สุดในการบอกว่าแนวโน้มยังดำเนินอยู่หรือเริ่มเสียโครงสร้าง',
    ],
    sections: [
      {
        id: 'uptrend',
        heading: 'โครงสร้างขาขึ้น',
        paragraphs: [
          'ขาขึ้นที่healthy ต้องมีทั้ง HH และ HL ต่อเนื่องกัน ถ้าราคาทำ HH แต่จุดต่ำใหม่ต่ำลงกว่าเดิม นั่นคือสัญญาณว่าแรงซื้อเริ่มไม่สม่ำเสมอ',
        ],
        bullets: ['HH + HL = ขาขึ้นสมบูรณ์', 'HL ถูกเบรก = โครงสร้างเริ่มเสีย', 'ไม่จำเป็นต้องทำ HH ทุกครั้งที่เด้ง'],
        steps: [],
      },
      {
        id: 'downtrend',
        heading: 'โครงสร้างขาลง',
        paragraphs: [
          'ขาลงคือการที่จุดสูงใหม่ต่ำลง (Lower High) และจุดต่ำใหม่ก็ต่ำลง (Lower Low) การเด้งขึ้นแต่ละครั้งจบต่ำกว่าครั้งก่อน',
        ],
        bullets: ['LH + LL = ขาลงสมบูรณ์', 'LH ถูกเบรก = แรงขายอ่อนลง', 'ควรดูกรอบใหญ่ประกอบเสมอ'],
        steps: [],
      },
      {
        id: 'practice',
        heading: 'ฝึกอ่านอย่างไร',
        paragraphs: [
          'เริ่มจากกรอบเวลาที่ชัด เช่น H4 แล้วใช้เครื่องหมายทำจุด swing high และ swing low ทุกจุด จากนั้นเขียนลำดับว่ามันยกขึ้นหรือกดลง ทำซ้ำจนอ่านได้เร็ว',
          'ควรฝึกอย่างน้อย 20 รอบบนคู่เงินเดียว แล้วกลับไปดูภายหลังว่าราคาไปทางไหนจริง การจดบันทึกแบบนี้ทำให้เห็นสถิติของตัวเอง เช่น swing ที่ยกขึ้นแล้วมักไปต่อได้อีก 40 ถึง 60 Pip บน H4 ซึ่งเป็นตัวเลขที่ใช้กำหนดเป้ากำไรได้จริงไม่ใช่เดา',
        ],
        bullets: [],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'swing high กับ swing low คืออะไร',
        a: 'คือจุดที่ราคาเปลี่ยนทิศในระดับย่อย โดยทั่วไปคือแท่งที่มีจุดสูงกว่าหรือต่ำกว่าแท่งข้างเคียงทั้งสองข้าง',
        a2: 'ตัวเลขที่ช่วยได้คือ swing high คือแท่งที่มีจุดสูงกว่าทั้งแท่งก่อนหน้าและถัดไป 1 แท่งขึ้นไป ในทางปฏิบัติควรใช้แท่งละ 2-3 แท่งประกอบกัน เพื่อกรองสัญญาณรบกวนในกรอบเล็ก',
      },
      {
        q: 'โครงสร้างเปลี่ยนเมื่อไร',
        a: 'เมื่อราคาเบรกจุด swing สำคัญที่ทำให้ลำดับ HH/HL หรือ LH/LL ขาดตอน การยืนยันควรมาจากแท่งปิด ไม่ใช่ไส้',
        a2: 'ตัวอย่างที่ชัดคือ ขาขึ้นที่มีลำดับ HH/HL ต่อเนื่อง ถ้าราคาเบรกจุด HL ล่าสุดและปิดต่ำกว่านั้น ให้ถือว่าโครงสร้างขาดตอน และควรหยุดมองหาการเข้าซื้อจนกว่าจะสร้างโครงสร้างใหม่',
      },
    ],
    related: ['forex-trend-direction', 'trendline-drawing', 'price-action'],
  },
  {
    slug: 'trend-reversal-signs',
    category: 'วิเคราะห์ Forex',
    categorySlug: 'forex-analysis',
    title: 'วิธีสังเกตการเปลี่ยนแปลงของแนวโน้มราคา',
    description:
      'สัญญาณเริ่มต้นที่บอกว่าแนวโน้มอาจกำลังเปลี่ยน พร้อมวิธีแยกการพักราคาออกจากการกลับตัวจริง',
    readingTime: '8 นาที',
    updatedDate: '2026-10-09',
    level: 'ปานกลาง',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20trend%20weakening%20chart%20illustration%20teal%20rising%20line%20flattening%20into%20warm%20orange%20range%20clean%20light%20background%20editorial%20flat%20fintech%20no%20text&width=1200&height=675&seq=art-trend-reversal-signs-01&orientation=landscape',
    tags: ['กลับตัว', 'แนวโน้ม', 'โครงสร้างตลาด'],
    intro: [
      'แนวโน้มไม่ได้จบด้วยแท่งเดียว แต่ค่อย ๆ สูญเสียโครงสร้างทีละขั้น การเห็นสัญญาณเริ่มต้นจึงมีค่ามากกว่าการรอให้กลับตัวเสร็จ',
      'แต่ก็ต้องแยกให้ออกระหว่างการพักราคาปกติกับการเปลี่ยนโครงสร้างจริง',
    ],
    sections: [
      {
        id: 'first',
        heading: 'สัญญาณเริ่มต้นที่ควรมอง',
        paragraphs: [
          'สัญญาณแรกที่พบบ่อยคือราคาไม่สามารถทำจุดสูงใหม่ได้ แม้จะพยายามหลายครั้ง ตามด้วยการหลุดจุดต่ำล่าสุดที่ไม่เคยหลุดมาก่อน',
        ],
        bullets: ['จุดสูงใหม่ทำไม่ได้หลายครั้ง', 'จุดต่ำล่าสุดถูกเบรก', 'แรงของแท่งเริ่มเล็กลงเรื่อย ๆ'],
        steps: [],
      },
      {
        id: 'confirm',
        heading: 'การยืนยันที่ควรมี',
        paragraphs: [
          'หลังหลุดโครงสร้างเดิม ให้ดูว่ามีการสร้างจุดสูงใหม่ในทิศตรงข้ามหรือไม่ ถ้าใช่ นั่นคือสัญญาณว่าโครงสร้างใหม่กำลังก่อตัว',
        ],
        bullets: ['แท่งปิดผ่านจุดสำคัญ', 'มีแรงตามมาหลังการเบรก', 'กรอบเวลาใหญ่เห็นการเปลี่ยนแปลงด้วย'],
        steps: [],
      },
      {
        id: 'pullback',
        heading: 'แยกพักราคาออกจากกลับตัว',
        paragraphs: [
          'การพักราคามักยังรักษาจุดต่ำล่าสุดไว้ได้ และกินเวลาไม่นานนัก ในขณะที่การกลับตัวจริงจะเบรกโครงสร้างและไม่กลับไปทำจุดสูงเดิม',
          'ข้อสังเกตที่ใช้แยกคือระยะเวลาและความลึก ถ้าราคาย้อนกลับไม่เกิน 38.2 ถึง 50% ของขาขึ้นเดิมและใช้เวลาไม่เกิน 8 ถึง 12 แท่งบน H4 มักเป็นการพักราคา แต่ถ้าย้อนเกิน 61.8% และใช้เวลานานกว่านั้น ให้เริ่มคิดว่าโครงสร้างกำลังเปลี่ยน ไม่ใช่แค่พัก',
        ],
        bullets: [],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'ต้องรอให้กลับตัวเสร็จก่อนเทรดไหม',
        a: 'การรอโครงสร้างใหม่ชัดเจนปลอดภัยกว่า แต่ก็แลกมาด้วยจุดเข้าที่แย่ลง ไม่มีคำตอบเดียว แต่ต้องรู้ว่าตัวเองรับความเสี่ยงแบบไหนได้',
        a2: 'ตัวเลขที่ควรรู้คือ การรอให้โครงสร้างใหม่ชัดเจนมักทำให้จุดเข้าแย่ลง 30-50% ของระยะเคลื่อนไหว แต่ลดโอกาสผิดจากราว 6 ใน 10 เหลือ 3 ใน 10 ทางเลือกที่สมดุลคือเข้าด้วยขนาดครึ่งหนึ่งตอนสัญญาณแรก แล้วเพิ่มอีกครึ่งเมื่อยืนยัน',
      },
      {
        q: 'สัญญาณกลับตัวบนกรอบเล็กเชื่อได้แค่ไหน',
        a: 'กรอบเล็กให้สัญญาณบ่อยแต่ล้มเหลวบ่อย ควรให้กรอบใหญ่สนับสนุนก่อนเสมอ',
        a2: 'ตัวเลขที่ต่างชัดคือ สัญญาณกลับตัวบน M5 ล้มเหลวราว 6-7 ใน 10 ครั้ง ส่วนบน H4 ลดเหลือราว 3-4 ใน 10 ครั้ง นี่คือเหตุผลที่ควรใช้กรอบเล็กเพียงหาจุดเข้า ไม่ใช่ใช้ตัดสินทิศทาง',
      },
    ],
    related: ['higher-high-lower-low', 'forex-trend-direction', 'how-to-analyze-forex-chart'],
  },
];